import { useLoaderData } from "@remix-run/react";
import { VStack, StackDivider } from "@chakra-ui/react";

import {
  FreeToTrySection,
  HomeHero,
  HowItWorksVideo,
  NotificationProof,
  ReviewSection,
  WhyCancellations,
} from "#app/components/index.jsx";
import { landingLoaderCountry } from "#app/components/landing/landingLoader.server.js";
import { getSeoMeta, getBaseUrl, getDefaultOgImage } from "#app/utils/meta.js";

const COUNTRY = "au";
// Secondary CTAs pre-scope the request form to this country.
const NEW_PATH = `/new?country=${COUNTRY}`;

const SUBTITLE =
  "Popular campgrounds across Australia book out fast. We monitor booking systems for cancellations and notify you when a spot opens up.";

export function meta({ matches }) {
  const baseUrl = getBaseUrl(matches);
  return getSeoMeta({
    title: "Australian Campground fully booked? Schnerp it!",
    description: SUBTITLE,
    url: `${baseUrl}/au`,
    image: getDefaultOgImage(baseUrl),
  });
}

export async function loader() {
  return landingLoaderCountry(COUNTRY, { tag: COUNTRY });
}

export default function Australia() {
  const { agencyIds, reviews, stats, recentOpenings, alertsSent } =
    useLoaderData();

  return (
    <VStack spacing={{ base: 10, md: 16 }} divider={<StackDivider />}>
      <HomeHero
        heading="Campground"
        subtitle={SUBTITLE}
        country={COUNTRY}
        agencyIds={agencyIds}
        reviews={reviews}
        stats={stats}
      />
      <HowItWorksVideo />
      <NotificationProof
        openings={recentOpenings}
        alertsSent={alertsSent}
        ctaTo={NEW_PATH}
      />
      <ReviewSection reviews={reviews} stats={stats} />
      <WhyCancellations />
      <FreeToTrySection ctaTo={NEW_PATH} />
    </VStack>
  );
}
